import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitActivationFilter } from '@apps-common/stores'
import { ISearchCountModel } from '@apps-common/types/general'

export const QUERY_SEARCH_UNIT_ACTIVATIONS_COUNT = (searchTerm?: string, status?: string, take?: number) =>
  ['getActivationsCount', searchTerm, status, take].filter(Boolean)

export const getActivationsCount = async (searchTerm: string, status: string, skip: number, take: number): Promise<ISearchCountModel> =>
  axios
    .get(`/UnitActivation/SearchUnitActivationRequestCount?searchTerm=${searchTerm}&status=${status}&skip=${skip}&take=${take}`)
    .then((res) => res.data?.data)

type QueryFnType = typeof getActivationsCount

type Props = {
  config?: QueryConfig<QueryFnType>
  model: IUnitActivationFilter
}

export const useSearchUnitActivationsCount = ({ config, model }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_SEARCH_UNIT_ACTIVATIONS_COUNT(model.searchVal, model.statusVal, model.take),
    queryFn: () => getActivationsCount(model.searchVal, model.statusVal, model.skip, model.take)
  })
